import { useAuth } from "../../hooks";
import React from "react";
import { UserAddress } from "../../api";
import ButtonLoader from "../Loader";
import { indiaFlag } from "../../Public/assets";
import { setSession } from "../../axios.config";
import { TextFormField } from "../Forms";

function RegisterForm2({ setStateVariable, stateVariable }) {
  const {
    formData,
    errors,
    normalizeFormData,
    handleFieldChange,
    validateFormPage2,
    setErrors,
    handleFieldBlur,
    loading,
    setLoading,
  } = useAuth();

  let address = formData?.address;

  // Remove special characters and replace them with spaces
  let cleanAddress = address?.replace(/[^a-zA-Z0-9\s]/g, " ");
  // Trim extra spaces at the beginning and end, and replace multiple spaces with a single space
  cleanAddress = cleanAddress?.replace(/\s+/g, " ").trim();

  const SignUpData = {
    address: cleanAddress,
    postcode: formData?.postcode,
    state: formData?.state,
    city: formData?.city,
  };

  const handleContinue = async () => {
    normalizeFormData();
    if (validateFormPage2()) {
      try {
        setLoading(true);
        const Address = await UserAddress(SignUpData);
        setSession("userId", Address?.data);
        setStateVariable(stateVariable + 1);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error.error) {
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            // Handle specific field errors from API
            if (error?.error) {
              Object.entries(error?.error).forEach(([key, value]) => {
                newErrors[key] = value;
              });
            }
            return newErrors;
          });
        }
      }
    }
  };
  return (
    <>
      <div className="w-full ">
        <div className="flex mb-[5px] justify-between ">
          <h1 className="text-[22px] lg:text-[26px]  leading-[26px] lg:leading-[34px]  font-geomanistMedium text-blackish  ">
            Address Details
          </h1>
          <h2 className="mt-2 text-[16px] text-blueish flex justify-end">
            Step 2/3
          </h2>
        </div>
        <p className="text-sm mb-[20px] xl:mb-[36px] text-greyish font-geomanistRegular">
          Please provide us your residential address.
        </p>

        <div
          className={`flex flex-col gap-y-[25px] gap-x-[46px] 
            `}
        >
          <div className="grid  grid-cols-1 gap-y-[12px] sm:grid-cols-2 gap-x-[46px]">
            {/* Pin code Input */}

            <TextFormField
              id={"postcode"}
              label={"Pin Code"}
              type={"number"}
              value={formData.postcode}
              onChange={handleFieldChange}
              onBlur={handleFieldBlur}
              error={errors.postcode}
            />

            {/* Country */}
            <div>
              <label
                htmlFor="Country"
                className="block text-[16px] font-geomanistRegular text-greyish mb-[9px] ml-2"
              >
                Country
              </label>
              <div className="flex bg-[#E7E7E7] h-10 w-full rounded-md border border-input p-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none focus:ring-0  text-blackShade !font-geomanistBold font-[16px] px-3 py-2 ">
                <img src={indiaFlag} alt="Flag" className="mr-2" />
                <span className="text-[16px] font-geomanistBold">INDIA</span>
              </div>
            </div>
          </div>

          <div className="w-full ">
            <TextFormField
              id={"address"}
              label={"Address"}
              type={"text"}
              value={formData.address}
              onChange={handleFieldChange}
              onBlur={handleFieldBlur}
              error={errors.address}
            />
          </div>

          <div className="grid  grid-cols-1 gap-y-[12px]  sm:grid-cols-2 gap-x-[46px]">
            <TextFormField
              id={"city"}
              label={"City"}
              type={"text"}
              value={formData.city}
              onChange={handleFieldChange}
              onBlur={handleFieldBlur}
              error={errors.city}
            />
            <TextFormField
              id={"state"}
              label={"State"}
              type={"text"}
              value={formData.state}
              onChange={handleFieldChange}
              onBlur={handleFieldBlur}
              error={errors.state}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full flex  justify-center  mt-[28px] text-white py-[10px] px-4 rounded-md  bg-blueish font-geomanistMedium leading-[23px] text-[18px] hover:pointer"
          onClick={handleContinue}
        >
          {loading && <ButtonLoader className={"mr-2 h-2"} />} Continue
        </button>
        <div
          onClick={() => setStateVariable(stateVariable - 1)}
          className=" flex justify-center text-blackShade  mt-[12px] font-geomanistMedium text-[18px] leading-[24px] underline hover:cursor-pointer "
        >
          Back
        </div>
        {/* </form> */}
      </div>
    </>
  );
}

export default RegisterForm2;
